import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'


//constants
import { Constants }         from '../../constants/Constants';

//components
import { BaseRequestComponent }                from '../../baseclasses/BaseRequest.component';
import {UserInfoComponent} from '../../components/ControlGroups/UserInfo.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {RequestHeaderComponent} from '../../components/Controls/RequestHeader.component';
import {ChangePhoneNumberDialogComponent} from '../../components/Employees/ChangePhoneNumberDialog.component';
import { ContactDetailsComponent } from '../ControlGroups/ContactDetails.component';
import { StatementDetailsComponent } from '../ControlGroups/StatementDetails.component';
import { AccountingDetailsComponent } from '../ControlGroups/AccountingDetails.component';
import { MICRDetailsComponent } from '../ControlGroups/MICRDetails.component';
import { GeneralDetailsComponent } from '../ControlGroups/GeneralDetails.component';
import {NotesComponent} from '../../components/ControlGroups/Notes.component';

// export const BASE_REQUEST_ACCESSOR: any = {
//     provide: NG_VALUE_ACCESSOR,
//     useExisting: forwardRef(() => CreateDriverRequestComponent),
//     multi: true
// };

@Component({
  selector: 'my-create-accounts-receivable-update-request',
  templateUrl: './CreateAccountsReceivableUpdateRequest.component.html',
  providers: [{provide: BaseRequestComponent, useExisting: forwardRef(() => CreateAccountsReceivableUpdateRequest)}]
})
export class CreateAccountsReceivableUpdateRequest extends BaseRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(ContactDetailsComponent) contactDetailsComponent: ContactDetailsComponent;
    @ViewChild(StatementDetailsComponent) statementDetailsComponent: StatementDetailsComponent;
    @ViewChild(AccountingDetailsComponent) accountingDetailsComponent: AccountingDetailsComponent;
    @ViewChild(MICRDetailsComponent) micrDetailsComponent: MICRDetailsComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;

    constructor()
    {
        super();
    }


    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
              this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();


    }

    onSaveClick(event: any){

        this.requestToSave = {
            ID: this.requestID,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            GeneralInfo: this.generalDetailsComponent.generalInfo,
            // ContactInfos: this.contactDetailsComponent.contactGridComponent.records,
            StatementInfo: this.statementDetailsComponent.statementInfo,
            AccountingInfo: this.accountingDetailsComponent.accountingInfo,
            MICRInfo: this.micrDetailsComponent.micrInfo,
            OtherInfo: this.notesComponent.otherInfo,
            RequestTypeID: enums.RequestTypeEnum.AccountsReceivableUpdate,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID,
            SalesOfficeID: this.userInfoComponent.userInfo.SalesOffice.ID,
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);
        util.RequestUtil.LoadRequestInvoiceNumbers(this.requestToSave, this.statementDetailsComponent.requestInvoiceNumbersComponent);

        this.requestToSave.RequestPaymentOptions = util.RequestUtil.LoadRequestPaymentOptions(this.requestToSave, this.accountingDetailsComponent.paymentOptionMultiSelectComponent);

        if (this.userInfoComponent.request.PhoneNumber){
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }


        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);

    }
    onYes(event: ent.Response){
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any){
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any){
        //do nothing
    }

}
